import { render } from "./SpacesPopUp.vue?vue&type=template&id=a6abf88c&scoped=true&ts=true"
import script from "./SpacesPopUp.vue?vue&type=script&lang=ts"
export * from "./SpacesPopUp.vue?vue&type=script&lang=ts"

import "./SpacesPopUp.vue?vue&type=style&index=0&id=a6abf88c&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6abf88c"]])

export default __exports__